import { Controller } from "stimulus";

const MOBILE_BREAKPOINT = 992;
const HIDE_DELAY_MS     = 800;
const FADE_DURATION_MS  = 300;

export default class extends Controller {
  static targets = ["menu"];

  connect() {
    this.hideDelayTimer = null;
    this.fadingTimer    = null;
    this.boundScroll    = this.hideImmediately.bind(this);
    window.addEventListener("scroll", this.boundScroll);
  }

  disconnect() {
    clearTimeout(this.hideDelayTimer);
    clearTimeout(this.fadingTimer);
    window.removeEventListener("scroll", this.boundScroll);
  }

  handleClick(event) {
    if (window.innerWidth < MOBILE_BREAKPOINT) {
      event.preventDefault();
      this.menuTarget.classList.toggle("show");
    }
  }

  show() {
    if (window.innerWidth < MOBILE_BREAKPOINT) return;
    clearTimeout(this.hideDelayTimer);
    clearTimeout(this.fadingTimer);

    document.querySelectorAll(".nav-dropdown-menu.show, .nav-dropdown-menu.hiding").forEach((menu) => {
      if (menu === this.menuTarget) return;
      menu.classList.remove("show");
      menu.classList.add("hiding");
      setTimeout(() => menu.classList.remove("hiding"), FADE_DURATION_MS);
    });

    this.menuTarget.classList.remove("hiding");
    this.menuTarget.classList.add("show");
  }

  scheduleHide() {
    if (window.innerWidth < MOBILE_BREAKPOINT) return;
    clearTimeout(this.hideDelayTimer);
    clearTimeout(this.fadingTimer);
    this.hideDelayTimer = setTimeout(() => {
      this.menuTarget.classList.add("hiding");
      this.fadingTimer = setTimeout(() => {
        this.menuTarget.classList.remove("show", "hiding");
      }, FADE_DURATION_MS);
    }, HIDE_DELAY_MS);
  }

  hideImmediately() {
    clearTimeout(this.hideDelayTimer);
    clearTimeout(this.fadingTimer);
    this.menuTarget.classList.remove("show", "hiding");
  }
}
